import { AssetFragment } from "../../api/graphql/bff/generated/fragments.service.graphql-gen";
import { Tradable } from "@models/interfaces/tradable";
import { TRADABLES_TYPE } from "@helpers/constants";

export class MarginAssetTradableAdapter extends Tradable {
	constructor(
		private readonly asset: AssetFragment,
		private readonly tradables: Tradable[]
	) {
		super();

		// Asset Settings (low-volatile)
		// @ts-expect-error assetSettings Protected
		this.assetSettings = {
			getMinBuy: () => 0,
			getMinSell: () => 0,
			getSort: () => 0,
			isAvailable: () => true,
			isBuyActive: () => asset.marginLongSettings?.buyActive ?? false,
			isSellActive: () => asset.marginLongSettings?.sellActive ?? false,
			isIndexOnly: () => false,
			isMaintenance: () => false
		};

		// Asset Price (high-volatile)
		// @ts-expect-error assetPrice Protected
		this.assetPrice = {
			getPrice: () => parseFloat(asset.price.value),
			getChange24h: () => parseFloat(asset.priceChange?.percentage.toString()) ?? 0,
			getChange1w: () => 0,
			getChange1m: () => 0,
			getChange6m: () => 0,
			getChange1y: () => 0,
			getChange5y: () => 0,
			getChange24hAmount: () => parseFloat(asset.priceChange?.value) ?? 0,
			getChange1wAmount: () => 0,
			getChange1mAmount: () => 0,
			getChange6mAmount: () => 0,
			getChange1yAmount: () => 0,
			getChange5yAmount: () => 0,
			getCirculatingSupply: () => 0
		};

		// Asset Info (optional)
		// @ts-expect-error assetInfo Protected
		this.assetInfo = {
			getInfo: () => this.asset.marginLongSettings.maximumLeverage.toString(),
			getDescription: () => "",
			getExtraInfo: () => "",
			getInfoIntegration: () => ""
		};
	}

	// Abstract method implementations
	public isTransferActive(): boolean {
		return false;
	}
	public isWithdrawActive(): boolean {
		return false;
	}
	public isDepositActive(): boolean {
		return false;
	}
	public isHodlTradable(): boolean {
		return false;
	}
	public isIota(): boolean {
		return false;
	}
	public isStellar(): boolean {
		return false;
	}

	public getId(): string {
		return this.tradables.find((tradable) => tradable.getPid() === this.asset.pid)?.getId();
	}
	public getPid(): string {
		return this.asset.pid;
	}
	public getName(): string {
		return this.asset.name;
	}
	public getSymbol(): string {
		return this.asset.marginLongSettings.maximumLeverage.toString();
	}
	public getLogoLight(): string {
		return this.asset.logos.find((l) => l.theme === "LIGHT")?.url ?? null;
	}
	public getLogoDark(): string {
		return this.asset.logos.find((l) => l.theme === "DARK")?.url ?? null;
	}
	public getPrecision(): number {
		return parseFloat(this.asset.price.precision.toString());
	}
	public getPrecisionFiat(): number {
		return parseFloat(this.asset.price.precision.toString());
	}
	public getPrecisionForTx(): number {
		return parseFloat(this.asset.price.precision.toString());
	}
	public getCurrencyType(): string {
		return TRADABLES_TYPE.LEVERAGED_TOKEN;
	}
	public isToken(): boolean {
		return true;
	}
	public getAssetGroupName(): string {
		return this.asset.__typename;
	}
	public getColor(): string {
		return "";
	}
}
